export const stockValidatorEvents = {
    RESET_STOCK_VALIDATOR: 'RESET_STOCK_VALIDATOR',
    STOCK_VALIDATOR_UPDATED: 'STOCK_VALIDATOR_UPDATED',
};

export const documentEvents = {
    NOT_COMMON_COMPONENTS_READY: 'NOT_COMMON_COMPONENTS_READY',
};
